import { useTranslation } from "react-i18next";

const LoadingScreen = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#FBFBFF] flex items-center justify-center">
      <div className="flex flex-col items-center justify-center text-center">
        <div className="relative">
          <div className="w-16 h-16 border-4 border-quaternary/20 rounded-full"></div>
          <div className="w-16 h-16 border-4 border-quaternary rounded-full border-t-transparent animate-spin absolute top-0"></div>
        </div>
        <p className="mt-4 text-quinary font-medium text-center">
          {t("loading_configurations")}
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
